import * as React from 'react';

const EyeNotAllowed = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <g fill="#fff" clipPath="url(#eyeNotAllowed_svg__a)">
      <path d="M19.165 8.167C17.498 6.75 14.748 5 10.998 5c-.416 0-.833 0-1.083.083-.5.084-.833.5-.75 1 .083.417.5.75.917.75.25 0 .583-.083.916-.083 3.25 0 5.667 1.5 7.084 2.75.25.167.416.5.416.917 0 .416-.166.666-.416.916-.5.417-1.084.834-1.667 1.167-.417.25-.5.75-.333 1.167.166.25.416.416.75.416.166 0 .25 0 .416-.083.667-.417 1.334-.833 1.917-1.333.667-.584 1-1.334 1-2.167 0-1-.333-1.75-1-2.333ZM4.498 2.75a.806.806 0 0 0-1.166 0 .806.806 0 0 0 0 1.167L5.665 6.25c-1.167.667-2.167 1.417-2.833 1.917-.667.583-1 1.333-1 2.25 0 .916.333 1.666 1 2.166C4.498 14 7.248 15.75 10.998 15.75c1.25 0 2.417-.167 3.584-.583l2.916 2.916a.9.9 0 0 0 .583.25.9.9 0 0 0 .584-.25.806.806 0 0 0 0-1.166L4.498 2.75Zm6.5 11.25c-3.25 0-5.666-1.5-7.083-2.75-.25-.167-.417-.5-.417-.833 0-.334.167-.667.417-.917.667-.583 1.75-1.333 3.083-1.917L9.165 9.75c-.083.167-.083.417-.083.667 0 1.083.833 1.916 1.916 1.916.25 0 .417-.083.667-.083l1.583 1.583c-.75.084-1.5.167-2.25.167Z" />
    </g>
    <defs>
      <clipPath id="eyeNotAllowed_svg__a">
        <path fill="#fff" d="M.998 0h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);

export default EyeNotAllowed;
